export const initialTimezone = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hourCycle: 'h12',
    timeZone: 'UTC',
    second: 'numeric',
    timeZoneName: 'short',
    language: 'en-AU',
    hour12: undefined,
};

export const hourOptions = [
    { id: 'h12', name: '12 Hours' },
    { id: 'h23', name: '24 Hours' },
];
